/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Resettablefilters2Inputs */

const en_btn_resettablefilters2 = /** @type {(inputs: Btn_Resettablefilters2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset Filters`)
};

/**
* | output |
* | --- |
* | "Reset Filters" |
*
* @param {Btn_Resettablefilters2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const btn_resettablefilters2 = /** @type {((inputs?: Btn_Resettablefilters2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Resettablefilters2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_btn_resettablefilters2(inputs)
});
export { btn_resettablefilters2 as "btn_resetTableFilters" }